import React from 'react';
import { connect } from 'react-redux';
import { Card, CardHeader, CardActions, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { createQuestion, updateQuestion, deleteQuestion } from '../actions/question';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import EditableAnswerList from '../components/EditableAnswerList';
import {withRouter} from 'react-router';
import Select from 'react-select';
import QuestionDomainLogicSettings from '../components/QuestionDomainLogicSettings';
import { Editor} from 'react-draft-wysiwyg';
import {EditorState, ContentState, convertFromHTML, convertToRaw} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import {uploadImage} from '../actions/sync';
import htmlToDraft from 'html-to-draftjs';
import {getResponse} from '../reducer/response';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {adminCardStyle} from '../containers/AdminHomepage';

window.htmlToDraft = htmlToDraft;
window.convertFromHTML = convertFromHTML;
let editorStyle = {
  height: 400,
  padding: 10
};

const deDup = (answers) => {
  const ids = {};
  const unique = [];
  for (const a of answers) {
    if (!ids[a.id]) {
      unique.push(a);
      ids[a.id] = true;
    }
  }
  return unique;
}

let toolbarStyle = {
  width: "100%",
  padding: "10px 0",
  border: 'none',
  borderBottom: '1px solid #efefef'
}

const toEditorState = (html) => {
  if (html === "" || !html) {
    const contentState = ContentState.createFromText("")
    return EditorState.createWithContent(contentState);
  } else {
    var blocksFromHTML;
    var contentBlocks;
    try {
      blocksFromHTML = htmlToDraft(html);
      contentBlocks = blocksFromHTML.contentBlocks;
    } catch(e) {
      blocksFromHTML = convertFromHTML(html);
      contentBlocks = blocksFromHTML.contentBlocks;
    }
    const contentState = ContentState.createFromBlockArray(contentBlocks);
    return EditorState.createWithContent(contentState);
  }
}

const toHtml = (editorState) => {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()))
}

function newBlankQuestion() {
  return {
    new: true,
    title: "",
    description: "",
    category: null,
    answers: [],
    answerType: "normal",
    satisfiedBy: [],
    notesPrompt: "",
    domainLogic: {
      caveats: {},
      criteria: {}
    },
    representationCategory: "Neither" // can be "Representation", "Implementation", "Both" or "Neither"
  }
}

let domainBgStyle = {backgroundColor:"white", color:"black"};

class QuestionForm extends React.Component {
  constructor(props) {
    super(props);

    let question = props.question || newBlankQuestion();

    this.state = {
      ...question,
      answers: deDup(question.answers),
      descriptionState: toEditorState(question.description || ""),
      notesPromptState: toEditorState(question.notesPrompt || ""),
      titleState: toEditorState(question.title || ""),
      satisfiedBy: this.idsToQuestions(question.satisfiedBy)
    }

    this.updateAnswers = this.updateAnswers.bind(this);
    this.checkCategory = this.checkCategory.bind(this);
    this.checkTitle = this.checkTitle.bind(this);
    this.checkAnswers = this.checkAnswers.bind(this);
    this.handleAnswerTypeChange = this.handleAnswerTypeChange.bind(this);
    this.handleSatisfiedByChange = this.handleSatisfiedByChange.bind(this);
  }

  // This shortcuts are needed because the db expects an array of ids,
  // but react-select needs objects with a value and label property
  idsToQuestions(ids) {
    if (ids && ids.length) {
      return ids.map((id) => this.props.questions.find((q) => q.id === id));
    } else {
      return [];
    }
  }

  questionsToIds(questions) {
    return questions.map((q) => q.id || q.value);
  }

  render() {
    let header = !this.state.new ? "Update Question" : "New Question";
    let toolbarConfig = {
      image: {
        uploadCallback: this.props.onUpload
      },
      link: {defaultTargetOption: '_blank'}
    }

    let questions;
    let answers;
    if (this.state.answerType === "satisfiedBy") {
      questions = this.state.satisfiedBy || [];
      answers = questions.map((q) => {
        return {
          label: q.title.replace(/<.*?>/gm, ''),
          options: q.answers.map((a) => ({label: q.title.replace(/<.*?>/gm, '') + ": " + a.title, value: a.id}))
        }
      });
    } else {
      answers = this.state.answers.map((a) => ({ value: a.id, label: a.title }));
      questions = [{
        ...this.props.question,
        answers: this.state.answers
      }];
    }

    let includedInSBQs = this.state.new ? [] : this.props.questions.filter((q) => q.answerType === 'satisfiedBy').filter((sbQ) => sbQ.satisfiedBy.includes(this.props.question.id));

    return (
      <Card style={adminCardStyle}>
        <CardHeader
          title={header}
        />
        <CardText>
          <SelectField errorText={this.state.categoryErrorText} floatingLabelText="Category" ref="category" style={{width: 300}} value={this.state.category} onChange={this.handleCategoryChange.bind(this)}>
            {
              this.props.categories.filter((c) => c.type === 'question').map((c) => <MenuItem key={c.id} value={c.id} primaryText={c.title} /> )
            }
          </SelectField>
          <br />
          <SelectField floatingLabelText="Representation or Implementation" style={{width: 300}} value={this.state.representationCategory || "Neither"} onChange={this.handleRepresentationCategoryChange}>
            <MenuItem value="Representation" primaryText="Representation" />
            <MenuItem value="Implementation" primaryText="Implementation" />
            <MenuItem value="Both" primaryText="Both" />
            <MenuItem value="Neither" primaryText="Neither" />
          </SelectField>

          <h4 style={{marginTop: 20, fontSize: 14, color: "black", fontWeight: '400', marginBottom:0}}>Title</h4>
          <h4 style={{marginTop: 20, fontSize: 12, color: "red", fontWeight: '600', display: (this.state.titleErrorText ? 'block' : 'none')}}>{this.state.titleErrorText ? this.state.titleErrorText : null}</h4>

          <Editor toolbar={{
            options: ['inline', 'colorPicker', 'link', 'remove', 'history'],
            inline: {options: ['bold', 'italic', 'underline', 'strikethrough']},
            link: {defaultTargetOption: '_blank'}
            }}
            editorStyle={{height:60}} toolbarStyle={toolbarStyle} editorState={this.state.titleState} onEditorStateChange={this.handleTitleStateChange} />


          <h4 style={{marginTop: 20, fontSize: 14, color: "black", fontWeight: '400', marginBottom:0}}>Description</h4>
          <Editor toolbar={toolbarConfig} editorStyle={editorStyle} toolbarStyle={toolbarStyle} editorState={this.state.descriptionState} onEditorStateChange={this.handleDescriptionChange} />
          <SelectField floatingLabelText="Answer Type" ref="answerType" value={this.state.answerType} onChange={this.handleAnswerTypeChange}>
            <MenuItem value="normal" primaryText="Normal" />
            <MenuItem value="satisfiedBy" primaryText="Satisfied By Other Questions" />
          </SelectField>
        </CardText>
        {
          (this.state.answerType === 'normal') ? (
              <Card style={{width:"90%", margin: "40px auto"}} zDepth={1}>
                <CardHeader title="Answers" />
                { this.state.answerErrorText ? <CardText style={{color: "red"}}>{this.state.answerErrorText}</CardText> : null}
                <EditableAnswerList response={this.props.response} answers={this.state.answers} onUpdate={this.updateAnswers} />
              </Card>
            ) : null
        }

        {
          (this.state.answerType === 'satisfiedBy') ? (
            <div>
            <CardHeader subtitle="Satisfying Questions" />
            <CardText style={{marginTop: -20}}>
            <Select
              name="satisfiedBy"
              getOptionLabel={(q) => {
                return q.title.replace(/<.*?>/gm, '');
              }}
              getOptionValue={(q) => q.id}
              value={this.state.satisfiedBy}
              options={this.props.questions}
              onChange={this.handleSatisfiedByChange}
              isMulti={true}
            />
            </CardText>
            </div>
          ) : includedInSBQs.length > 0 ?
                <CardText>
                  <b>This question is included in the following grouped criteria questions</b><br />
                  <ul>{includedInSBQs.map((sbQ) => <li>{sbQ.id}: {sbQ.title.replace(/<.*?>/gm, '')}</li>)}</ul>
                </CardText>
              : <CardText>
                  <b>This question is not included in any grouped criteria questions.</b>
                </CardText>
        }
        <CardText>
          <h4 style={{marginTop: 20, fontSize: 12, color: "grey", fontWeight: '200'}}>Note Taking Prompt</h4>
          <Editor toolbar={toolbarConfig} editorStyle={{...editorStyle, height: 200}} toolbarStyle={toolbarStyle} editorState={this.state.notesPromptState} onEditorStateChange={this.handleNotesPromptChange} />
        </CardText>
        <Card style={{width:"90%", margin: "40px auto"}} zDepth={1}>
        <CardHeader style={domainBgStyle} title="Domain Logic" />
          <QuestionDomainLogicSettings
            ref="domainLogicSettings"
            domainLogic={this.state.domainLogic}
            options={this.props.options}
            categories={this.props.optionCategories}
            questions={questions}
            answers={answers}
          />
        </Card>
        <CardText>
        <CardActions style={{textAlign: 'right'}}>
          {!this.state.new ? <FlatButton onClick={this.delete.bind(this)} label="delete" /> : ""}
          <FlatButton onClick={this.cancel.bind(this)} label="cancel" />
          <RaisedButton onClick={this.submit.bind(this)} primary={true} label="Save Question" />
        </CardActions>
        </CardText>
      </Card>
    )
  }

  updateAnswers(answers) {
    this.setState({answers: answers});
  }

  handleSectionChange(event, index, value){
    this.setState({section: value})
  }

  handleAnswerTypeChange(e, i, value) {
    this.setState({answerType: value})
  }

  handleSatisfiedByChange(values) {
    this.setState({
      satisfiedBy: values
    });
  }

  handleCategoryChange(event, index, value){
    this.setState({category: value});
    this.checkCategory(value)
  }

  handleRepresentationCategoryChange = (event, i, value) => {
    this.setState({representationCategory: value});
  }

  checkTitle() {
    var htmlTitle = toHtml(this.state.titleState);
    if (htmlTitle === "<p></p>" || htmlTitle === "<p></p>\n" || htmlTitle.length === 0) {
      this.setState({titleErrorText: "Question title required"});
      return false;
    } else {
      this.setState({titleErrorText: ""});
      return true;
    }
  }

  checkCategory(value) {
    if (this.state.category || value) {
      this.setState({categoryErrorText: ""});
      return true;
    } else {
      this.setState({categoryErrorText: "Category required"});
      return false;
    }
  }

  checkAnswers() {
    if (this.state.answers.length || this.state.answerType === 'satisfiedBy') {
      this.setState({answerErrorText: ""})
      return true;
    } else {
      this.setState({answerErrorText: "You must specify at least one answer"})
      return false;
    }
  }

  handleDescriptionChange = (v) => {
    this.setState({descriptionState: v});
  }

  handleTitleStateChange = (v) => {
    this.setState({titleState: v});
  }

  handleNotesPromptChange = (v) => {
    this.setState({notesPromptState: v});
  }

  validateFields(){
    //validate each to trigger error text for all that are missing
    let titleValidated = this.checkTitle();
    let categoryValidated = this.checkCategory();
    let answersValidated = this.checkAnswers();

    if(titleValidated && categoryValidated && answersValidated){
      return true;
    } else {
      return false;
    }
  }

  submit() {
    if (this.validateFields()) {
      let attrs = {
        title: toHtml(this.state.titleState),
        description: toHtml(this.state.descriptionState),
        answerType: this.state.answerType,
        category: this.state.category,
        answers: this.state.answers,
        domainLogic: this.refs.domainLogicSettings.getValue(),
        notesPrompt: toHtml(this.state.notesPromptState),
        representationCategory: this.state.representationCategory,
        satisfiedBy: this.questionsToIds(this.state.satisfiedBy)
      };
      if (!this.state.new) {
        this.props.onUpdate(this.props.question.id, attrs)
      } else {
        this.props.onCreate(attrs);
      }
      this.goBack(this.state.new);
    } else {
      alert("Required fields are missing.")
    }
  }

  delete() {
    var sbQs = this.props.questions.filter((q) => q.answerType === 'satisfiedBy');
    if(sbQs.flatMap(sbQ => sbQ.satisfiedBy).includes(this.props.question.id)){
      var idsContainingQuestion = sbQs.filter(q => q.satisfiedBy.includes(this.props.question.id)).map(q => q.id)
      alert("Cannot delete. This question is contained in a satisfied by (grouped) question. It must be removed from all satisfied by questions before being deleted. Satisfied By question IDs that this is contained in: " + idsContainingQuestion)
    } else {
        if (global.confirm("Are you sure you want to delete this question?")) {
          this.props.onDelete(this.props.question.id);
          this.goBack();
        }
      }
    }

  cancel() {
    this.goBack();
  }

  goBack(isNew = false) {
    if(isNew){
      alert("You will now be taken to update the question order. Please update the order in all sections this question will occur.")
      this.props.router.push('/admin/questionOrder')
    } else {
      this.props.router.push('/admin/questions');
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  let id = parseInt(ownProps.routeParams.id);
  return {
    question: state.questions.find((t) => t.id === id),
    questions: state.questions,
    categories: state.categories,
    optionCategories: state.categories.filter((t) => t.type === 'option' || t.type === 'target'),
    options: state.options,
    response: getResponse(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onCreate: (props) => dispatch(createQuestion(props)),
    onUpdate: (id, props) => dispatch(updateQuestion(id, props)),
    onDelete: (id) => dispatch(deleteQuestion(id)),
    onUpload: (file) => dispatch(uploadImage(file))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QuestionForm));
